import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@careflux/primitives';
import { useState } from 'react';
import { QueryState } from './QueryState';
import { VerificationTable } from './VerificationTable';
import type { VerificationTabProps } from './components.types';
import type { VerificationDimension } from './types';
import { useSummaryVerification } from './useSummaryQualityQueries';

const VERIFICATION_DIMENSIONS: { value: VerificationDimension; label: string }[] = [
  { value: 'severity', label: 'Alvarleiki' },
  { value: 'category', label: 'Flokkur' },
  { value: 'finder', label: 'Finnandi (líkan)' },
  { value: 'verifier', label: 'Sannreynir (líkan)' },
];

export const VerificationTab = ({ filters }: VerificationTabProps) => {
  const [by, setBy] = useState<VerificationDimension>('severity');
  const verificationQuery = useSummaryVerification(filters, by);

  return (
    <Card padding="lg">
      <CardHeader>
        <CardTitle>Ábendingar sannprófunar</CardTitle>
        <CardDescription>Hlutföll eru reiknuð yfir svaraðar ábendingar</CardDescription>
        <CardAction>
          <Select value={by} onValueChange={(value) => setBy(value as VerificationDimension)}>
            <SelectTrigger className="w-[200px]" aria-label="Flokka eftir">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {VERIFICATION_DIMENSIONS.map((dimension) => (
                <SelectItem key={dimension.value} value={dimension.value}>
                  {dimension.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </CardAction>
      </CardHeader>
      <CardContent>
        <QueryState
          isLoading={verificationQuery.isLoading}
          isError={verificationQuery.isError}
          error={verificationQuery.error}
          onRetry={() => void verificationQuery.refetch()}
          loadingLabel="Sæki ábendingar"
          errorTitle="Ábendingar hlóðust ekki"
        />
        {verificationQuery.data && (
          <VerificationTable
            rows={verificationQuery.data}
            dimensionLabel={VERIFICATION_DIMENSIONS.find((dimension) => dimension.value === by)?.label ?? ''}
          />
        )}
      </CardContent>
    </Card>
  );
};
